import { render } from "./Top10ListItem.vue?vue&type=template&id=30ae6874&scoped=true"
import script from "./Top10ListItem.vue?vue&type=script&lang=js"
export * from "./Top10ListItem.vue?vue&type=script&lang=js"

import "./Top10ListItem.vue?vue&type=style&index=0&id=30ae6874&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ae6874"]])

export default __exports__